import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import ShadowDOMDemoNoSnap from './ShadowDOMDemoNoSnap';
import ClientProvider from './client';
export default createDemo(import.meta.url, ShadowDOMDemoNoSnap, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/customization/shadow-dom/demos/demo-no-snap/ShadowDOMDemoNoSnap.js",
    "fileName": "ShadowDOMDemoNoSnap.js",
    "language": "javascript",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 0,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "export default function ShadowDOMDemoNoSnap() {\n  return (\n    <iframe\n      title=\"codesandbox\"\n      src=\"https://codesandbox.io/embed/6vcl2f?view=Editor+%2B+Preview&module=%2Findex.tsx\"\n      style={{\n        width: '100%',\n        height: 350,\n        border: 0,\n      }}\n      sandbox=\"allow-forms allow-modals allow-popups allow-presentation allow-same-origin allow-scripts\"\n    />\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 14,
        "focusedLines": 14,
        "collapsible": false
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 0
        },
        "export default function ShadowDOMDemoNoSnap() {\n  return (\n    <iframe\n      title=\"codesandbox\"\n      src=\"https://codesandbox.io/embed/6vcl2f?view=Editor+%2B+Preview&module=%2Findex.tsx\"\n      style={{\n        width: '100%',\n        height: 350,\n        border: 0,\n      }}\n      sandbox=\"allow-forms allow-modals allow-popups allow-presentation allow-same-origin allow-scripts\"\n    />\n  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "0": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 0
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 1
            },
            [
              [
                "span",
                "pl-k",
                "export"
              ],
              " ",
              [
                "span",
                "pl-c1",
                "default"
              ],
              " ",
              [
                "span",
                "pl-k",
                "function"
              ],
              " ",
              [
                "span",
                "pl-en",
                "ShadowDOMDemoNoSnap"
              ],
              "() {"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 2
            },
            [
              "  ",
              [
                "span",
                "pl-k",
                "return"
              ],
              " ("
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 3
            },
            [
              "    ",
              [
                "span",
                "pl-k di-pu",
                "<"
              ],
              "iframe"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 4
            },
            [
              "      title",
              [
                "span",
                "pl-k di-pu",
                "="
              ],
              [
                "span",
                "pl-s",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "codesandbox",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 5
            },
            [
              "      src",
              [
                "span",
                "pl-k di-pu",
                "="
              ],
              [
                "span",
                "pl-s",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "https://codesandbox.io/embed/6vcl2f?view=Editor+%2B+Preview&module=%2Findex.tsx",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 6
            },
            [
              "      style",
              [
                "span",
                "pl-k di-pu",
                "="
              ],
              "{{"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 7
            },
            [
              "        width",
              [
                "span",
                "pl-k di-pu",
                ":"
              ],
              " ",
              [
                "span",
                "pl-s",
                [
                  [
                    "span",
                    "pl-pds",
                    "'"
                  ],
                  "100%",
                  [
                    "span",
                    "pl-pds",
                    "'"
                  ]
                ]
              ],
              ","
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 8
            },
            [
              "        height",
              [
                "span",
                "pl-k di-pu",
                ":"
              ],
              " ",
              [
                "span",
                "pl-c1 di-num",
                "350"
              ],
              ","
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 9
            },
            [
              "        border",
              [
                "span",
                "pl-k di-pu",
                ":"
              ],
              " ",
              [
                "span",
                "pl-c1 di-num",
                "0"
              ],
              ","
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 10
            },
            "      }}"
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 11
            },
            [
              "      sandbox",
              [
                "span",
                "pl-k di-pu",
                "="
              ],
              [
                "span",
                "pl-s",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "allow-forms allow-modals allow-popups allow-presentation allow-same-origin allow-scripts",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 12
            },
            [
              "    ",
              [
                "span",
                "pl-k di-pu",
                "/>"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 13
            },
            "  );"
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 14
            },
            "}"
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 14,
    "focusedLines": 14,
    "collapsible": false
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
